import React, { useState } from "react";
import Layout from "../components/layout";
import toast from "react-hot-toast";
import "../index.css";
import axios from "axios";

/** recolte des donnees santymed -> AGA */
const UpdateData = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(false);

  const startCopy = async () => {
    setIsLoading(true);
    setError(null);
    setSuccess(false);

    let endpoint = `${process.env.REACT_APP_API_URL}/santymed/copy-data`;
    const token = localStorage.getItem("token");
    console.log("Token from localStorage:", token); // Added console log

    try {
      await axios.get(endpoint, {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      });
    } catch (error) {
      setError("Error copying data");
    } finally {
      setIsLoading(false);
    }
  };

  const startImport = async () => {
    setIsLoading(true);
    setError(null);
    setSuccess(false);

    let endpoint = `${process.env.REACT_APP_API_URL}/auth/process-all-santymed`;
    const token = localStorage.getItem("token");

    if (!token) {
      console.error("Token is null or undefined!");
      setIsLoading(false);
      setError("Token not found. Please log in.");
      return; // Stop execution
    }

    console.log("Token being sent:", token); // Log the token

    try {
      await axios.post(
        endpoint,
        {},
        {
          headers: {
            Authorization: "Bearer " + token,
          },
        }
      );
    } catch (error) {
      console.error("Axios Error:", error);
      setError("Error importing data");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="px-5 mt-3">
      <div className="d-flex justify-content-center">
        <h3 className="page-title">Mise à jour des données</h3>
      </div>
      <p>
        <strong>Que se passe-t-il :</strong>
      </p>
      <ul>
        <li>
          Récupération des Données : Les données de Santymed vont être
          importées. Ce processus peut prendre un certain temps, en fonction de
          la quantité de données.
        </li>
        <li>
          Statut Actuel : Vous recevrez des mises à jour ici pendant que nous
          procédons à la copie des données.
        </li>
      </ul>
      <p>
        <strong>Notifications :</strong>
      </p>
      <ul>
        <li>
          <strong>En Cours :</strong> Si la tâche est en cours, vous verrez un
          message indiquant que la copie des données est en cours.
        </li>
        <li>
          <strong>Succès :</strong> Une fois les données copiées avec succès,
          vous recevrez un message de confirmation.
        </li>
        <li>
          <strong>Erreur :</strong> S’il y a un problème durant le processus,
          nous vous informerons et vous fournirons des détails sur le problème.
        </li>
      </ul>
      <p>
        <strong>Note :</strong> Merci de ne pas quitter cette page pendant que
        la copie des données est en cours. Votre patience est appréciée !
      </p>

      <div className="button-group">
        <button onClick={startCopy}>Récupérer Données Santymed</button>
      </div>
      {isLoading && <p>La copie des données est en cours...</p>}
      {success && <p>Données copiées avec succès !</p>}
      {error && <p>{error}</p>}
    </div>
  );
};

export default UpdateData;
